import { BulkHistoryRecord } from "../types/CustomRecords";
import { zendeskRequest } from "./zendesk";

export async function getBulkHistory() {
  return zendeskRequest<{
    custom_object_records: BulkHistoryRecord[];
  }>(
    "/api/v2/custom_objects/bulk_ops_relatorio/records?page[size]=100",
    "GET"
  );
}
